// extracted by mini-css-extract-plugin
export default {"input":"CoMakers_input__dbfks","column":"CoMakers_column__VJ4Jx"};